import { baseApi } from './baseApi.ts';
import type { UserDto } from '@/app/common/types/user.ts';
import type {
  LoginDto,
  LoginResponseDto,
  ChangePasswordDto,
  ChangePasswordResultDto,
  ForgotPasswordDto,
  ForgotPasswordResultDto,
  ResetPasswordDto,
  ResetPasswordResultDto,
} from '@/app/common/types/auth.ts';

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponseDto, LoginDto>({
      query: (body) => ({ url: 'users/login', method: 'POST', body }),
    }),
    getMe: builder.query<UserDto, void>({
      query: () => 'users/me',
      providesTags: ['User'],
    }),
    updateUser: builder.mutation<UserDto, Partial<UserDto> & { id: number }>({
      query: (user) => ({ url: `users/${user.id}`, method: 'PUT', body: user }),
      invalidatesTags: ['User'],
    }),
    changePassword: builder.mutation<ChangePasswordResultDto, ChangePasswordDto>({
      query: (body) => ({ url: 'users/change-password', method: 'POST', body }),
    }),
    forgotPassword: builder.mutation<ForgotPasswordResultDto, ForgotPasswordDto>({
      query: (body) => ({ url: 'users/forgot-password', method: 'POST', body }),
    }),
    resetPassword: builder.mutation<ResetPasswordResultDto, ResetPasswordDto>({
      query: (body) => ({ url: 'users/reset-password', method: 'POST', body }),
    }),
    uploadUserIcon: builder.mutation<string, FormData>({
      query: (formData) => ({ url: 'users/upload-icon', method: 'POST', body: formData }),
      invalidatesTags: ['User'],
    }),
    exportData: builder.query<unknown, void>({
      query: () => 'users/export-data',
    }),
    getDemoToken: builder.query<{ token: string }, void>({
      query: () => 'users/demo-token',
    }),
  }),
});

export const {
  useLoginMutation,
  useGetMeQuery,
  useLazyGetMeQuery,
  useUpdateUserMutation,
  useChangePasswordMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useUploadUserIconMutation,
  useLazyExportDataQuery,
  useLazyGetDemoTokenQuery,
} = userApi;
